import { StyledTrack } from './styles/CreditsTrack.styles';

export type CreditsTrackProps = {
  index: number;
  tierCount: number;
  onIndexChange: (index: number) => void;
};

const CreditsTrack = ({
  index,
  tierCount,
  onIndexChange,
}: CreditsTrackProps) => {
  const marks = Array.from({ length: tierCount }, (_, i) => ({ value: i }));

  return (
    <StyledTrack
      value={index}
      min={0}
      max={Math.max(tierCount - 1, 0)}
      step={1}
      marks={marks}
      onChange={(_, value) => onIndexChange(value as number)}
      aria-label="Credits"
    />
  );
};

export default CreditsTrack;
